
export default {
  introducerLogo: null,
  onboardingLogo: null,
};
